import React, { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";

function WhatsAppFloat() {
  const [position, setPosition] = useState({
    x: window.innerWidth - 80,
    y: window.innerHeight - 80,
  });

  const [dragging, setDragging] = useState(false);

  
  const startDrag = (e) => {
    e.preventDefault(); 
    setDragging(true);
  };

  
  const onDrag = (e) => {
    if (!dragging) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    setPosition({
      x: clientX - 30,
      y: clientY - 30,
    });
  };

  
  const endDrag = () => {
    setDragging(false);
  };

  
  useEffect(() => {
    window.addEventListener("mousemove", onDrag);
    window.addEventListener("mouseup", endDrag);
    window.addEventListener("touchmove", onDrag, { passive: false });
    window.addEventListener("touchend", endDrag);

    return () => {
      window.removeEventListener("mousemove", onDrag);
      window.removeEventListener("mouseup", endDrag);
      window.removeEventListener("touchmove", onDrag);
      window.removeEventListener("touchend", endDrag);
    };
  });

  return (
    <a
      href="https://wa.me/YOURNUMBERHERE"
      target="_blank"
      rel="noreferrer"
      onMouseDown={startDrag}
      onTouchStart={startDrag}
      style={{
        position: "fixed",
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: "60px",
        height: "60px",
        backgroundColor: "#25D366",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontSize: "30px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
        cursor: "grab",
        zIndex: 9999,
        userSelect: "none",
        touchAction: "none", 
        transition: dragging ? "none" : "0.2s ease",
      }}
    >
      <FaWhatsapp />
    </a>
  );
}

export default WhatsAppFloat;